import React from "react";
import LegalShell from "./LegalShell";

export default function Cookies() {
  return (
    <LegalShell title="Política de Cookies" updated="Junio de 2026" path="cookies" description="Información sobre las cookies técnicas y analíticas que utiliza España Eficiente (E²).">
      <p>
        Este sitio utiliza cookies y tecnologías similares. A continuación te
        explicamos cuáles usamos y para qué, conforme al artículo 22.2 de la
        LSSI-CE y a la normativa de protección de datos.
      </p>

      <h2 className="text-xl font-bold text-foreground pt-2">1. ¿Qué es una cookie?</h2>
      <p>
        Una cookie es un pequeño archivo que se almacena en tu dispositivo al
        visitar una web y permite recordar información sobre tu navegación.
      </p>

      <h2 className="text-xl font-bold text-foreground pt-2">2. Tipos de cookies que usamos</h2>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          <strong>Técnicas (necesarias):</strong> imprescindibles para el
          funcionamiento básico del sitio. No requieren consentimiento.
        </li>
        <li>
          <strong>Analíticas:</strong> nos ayudan a entender de forma agregada y
          anónima cómo se usa la web para mejorarla. Solo se activan con tu
          consentimiento.
        </li>
      </ul>

      <h2 className="text-xl font-bold text-foreground pt-2">3. Gestión de cookies</h2>
      <p>
        Puedes aceptar o rechazar las cookies analíticas desde el aviso que se
        muestra al entrar en la web. Además, puedes configurar o eliminar las
        cookies en cualquier momento desde los ajustes de tu navegador (Chrome,
        Firefox, Safari, Edge, etc.).
      </p>

      <h2 className="text-xl font-bold text-foreground pt-2">4. Cambios</h2>
      <p>
        Podemos actualizar esta política para adaptarla a cambios normativos o
        técnicos. Te recomendamos revisarla periódicamente.
      </p>
    </LegalShell>
  );
}
